const getLocalShowPrintBillButton = () => {
  const val = localStorage.getItem("showPrintBillButton");
  return val === null ? true : val === "true";
};
export default getLocalShowPrintBillButton;
